export default function ContentWrapper({ children, className = null }) {
	return (
		<>
			<div id="content-wrapper" className={className} style={{background:'#121212', minHeight:'100vh'}}>
				{children}
			</div>
		</>
	);
}
